import React from 'react';
import { Search, BookOpen, Beaker, Sparkles } from 'lucide-react';
const steps = [{
  icon: Search,
  title: 'Buscas el síntoma',
  desc: 'Encuentras lo que te pasa en el índice por categoría.'
}, {
  icon: BookOpen,
  title: 'Lees el remedio',
  desc: 'Cada remedio explica ingredientes y para qué sirve.'
}, {
  icon: Beaker,
  title: 'Lo preparas',
  desc: 'Paso a paso con ingredientes simples y comunes.'
}, {
  icon: Sparkles,
  title: 'Lo incorporas',
  desc: 'Sumas un hábito natural a tu día a día.'
}];
export function HowItWorks() {
  return <section className="py-8 md:py-12 px-5 bg-cream-50" data-id="element-170">
      <div className="max-w-4xl mx-auto" data-id="element-171">
        <div className="text-center mb-8 md:mb-12 max-w-2xl mx-auto" data-id="element-172">
          <p className="text-xs uppercase tracking-[0.2em] text-olive-600 font-medium mb-4" data-id="element-173">
            Cómo se usa
          </p>
          <h2 className="font-serif font-medium text-3xl md:text-4xl text-ink-900 leading-tight" data-id="element-174">
            Simple, práctico,{' '}
            <span className="italic text-olive-600" data-id="element-175">en minutos</span>
          </h2>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6" data-id="element-176">
          {steps.map((step, idx) => {
          const Icon = step.icon;
          return <div key={idx} className="relative" data-id="element-177">
                <div className="bg-cream-100 border border-cream-300 rounded-2xl p-5 md:p-6 h-full" data-id="element-178">
                  <div className="flex items-center gap-2 mb-4" data-id="element-179">
                    <span className="font-serif text-2xl text-olive-400 font-medium" data-id="element-180">
                      0{idx + 1}
                    </span>
                    <div className="flex-1 h-px bg-cream-300" data-id="element-181"></div>
                  </div>
                  <Icon className="w-6 h-6 text-olive-600 mb-3" strokeWidth={1.8} data-id="element-182" />
                  <h3 className="font-serif font-medium text-ink-900 text-base md:text-lg leading-tight mb-2" data-id="element-183">
                    {step.title}
                  </h3>
                  <p className="text-sm text-ink-700 leading-relaxed" data-id="element-184">
                    {step.desc}
                  </p>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}